import { Box } from '../layout/box';
import { styled, Theme } from '../../styles';
export const SideGradient = styled(Box)(({ theme, animated }) => {
    return {
        position: 'absolute',
        width: '8px',
        left: '0',
        top: '0',
        bottom: '0',
        background: `linear-gradient( ${theme.colors.azure} 0%, #00BFFF 57.47%, #23E5E5 100%)`,
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
        backgroundSize: animated ? '100% 200%' : null,
        animation: animated ? `${Theme.keyframes.backgroundVerticalPulse} 2s ease infinite` : null,
    };
});
export const TopGradient = styled(Box)(({ theme, animated, customAnimatedColor }) => ({
    position: 'absolute',
    height: '8px',
    left: '0',
    top: '0',
    right: '0',
    background: animated
        ? `linear-gradient(
        to right,
        ${customAnimatedColor ? theme.colors.white : '#00BFFF'} 0%,
        ${customAnimatedColor ?? theme.colors.azure} 10%,
        ${customAnimatedColor ?? '#00BFFF'} 35%,
        ${customAnimatedColor ?? '#23E5E5'} 40%,
        ${customAnimatedColor ? theme.colors.white : '#00BFFF'} 45%,
        ${customAnimatedColor ?? theme.colors.azure} 60%,
        ${customAnimatedColor ?? '#00BFFF'} 75%,
        ${customAnimatedColor ?? '#23E5E5'} 80%,
        ${customAnimatedColor ? theme.colors.white : '#00BFFF'} 85%,
        ${customAnimatedColor ?? theme.colors.azure} 100%
    )`
        : `linear-gradient(to right, ${theme.colors.azure} 0%, #00BFFF 57.47%, #23E5E5 100%)`,
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    backgroundSize: animated ? '600% 100%' : null,
    animation: animated
        ? `${Theme.keyframes.backgroundHorizontalPulseLTR} 2s linear infinite`
        : null,
    animationFillMode: 'backwards',
}));
export const SideSolid = styled.div(({ theme, decoratorColor }) => {
    return {
        position: 'absolute',
        width: '8px',
        left: '0',
        top: '0',
        bottom: '0',
        background: theme.colors[decoratorColor],
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
    };
});
export const TopSolid = styled.div(({ theme, decoratorColor }) => {
    return {
        position: 'absolute',
        height: '8px',
        left: '0',
        top: '0',
        right: '0',
        background: theme.colors[decoratorColor],
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
    };
});
//# sourceMappingURL=decorators.js.map